module.exports = __webpack_public_path__ + "img/best-price-ru-m.e79d8a9.webp";